"use client";

import { c as _c } from "react/compiler-runtime";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { GRADIENT_CONTRACT, MEMELAB_CONTRACT, MEMES_CONTRACT } from "@/constants/constants";
import type { Distribution } from "@/entities/IDistribution";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import { areEqualAddresses, capitalizeEveryWord } from "@/helpers/Helpers";
import { useEffect, useState } from "react";
import UserPageStatsActivityDistributionsTableItem from "./UserPageStatsActivityDistributionsTableItem";
export enum DistributionCollection {
  MEMES = "MEMES",
  GRADIENTS = "GRADIENTS",
  MEMELAB = "MEMELAB",
}
export interface DistributionTableItem {
  readonly collection: DistributionCollection;
  readonly tokenId: number;
  readonly name: string;
  readonly wallet: string;
  readonly phases: number[];
  readonly amountMinted: number;
  readonly amountTotal: number;
  readonly date: string;
}
export default function UserPageStatsActivityDistributionsTable(t0) {
  const $ = _c(32);
  const {
    items,
    profile,
    loading
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = () => {
      const phases = new Set();
      for (const item of items) {
        for (const p of item.phases) {
          phases.add(p);
        }
      }
      return Array.from(phases);
    };
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getAvailablePhases = t1;
  let t2;
  if ($[2] !== getAvailablePhases) {
    t2 = getAvailablePhases();
    $[2] = getAvailablePhases;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [availablePhases, setAvailablePhases] = useState(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [results, setResults] = useState(t3);
  const getCollectionEnum = _temp;
  const getItemPhaseAmount = _temp2;
  let t4;
  if ($[5] !== getAvailablePhases || $[6] !== items || $[7] !== profile) {
    t4 = () => {
      const phases_0 = getAvailablePhases();
      setAvailablePhases(phases_0);
      setResults(items.map(item_1 => ({
        collection: getCollectionEnum(item_1.contract),
        tokenId: item_1.card_id,
        name: item_1.card_name,
        wallet: profile.wallets?.find(w => w.wallet.toLowerCase() === item_1.wallet.toLowerCase())?.display ?? item_1.wallet_display ?? item_1.wallet,
        phases: phases_0.map(phase_0 => getItemPhaseAmount({
          phase: phase_0,
          item: item_1
        })),
        amountMinted: item_1.minted,
        amountTotal: item_1.total_count,
        date: item_1.mint_date
      })));
    };
    $[5] = getAvailablePhases;
    $[6] = items;
    $[7] = profile;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== items) {
    t5 = [items];
    $[9] = items;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <th scope="col" className="tw-group tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md lg:tw-pr-4">Collection</th>;
    t7 = <th scope="col" className="tw-group tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-right tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md lg:tw-pl-4">Token</th>;
    t8 = <th scope="col" className="tw-group tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md lg:tw-pl-4">Name</th>;
    t9 = <th scope="col" className="tw-group tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md lg:tw-pl-4">Wallet</th>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[15] !== availablePhases) {
    t10 = availablePhases.map(_temp3);
    $[15] = availablePhases;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <th scope="col" className="tw-group tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-right tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md lg:tw-pl-4">Minted</th>;
    t12 = <th scope="col" className="tw-group tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-right tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md lg:tw-pl-4">Total</th>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t11 = $[17];
    t12 = $[18];
  }
  const t13 = loading ? "tw-opacity-100" : "tw-opacity-0";
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <CircleLoader />;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t13) {
    t15 = <th scope="col" className="tw-group tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-right tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md lg:tw-pl-4"><div className={t13}>{t14}</div></th>;
    $[20] = t13;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t10 || $[23] !== t15) {
    t16 = <thead className="tw-bg-iron-900"><tr>{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t15}</tr></thead>;
    $[22] = t10;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== results) {
    t17 = results.map(_temp4);
    $[25] = results;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t17) {
    t18 = <tbody className="tw-divide-y tw-divide-iron-800">{t17}</tbody>;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t16 || $[30] !== t18) {
    t19 = <table className="tw-min-w-full tw-divide-y tw-divide-iron-700">{t16}{t18}</table>;
    $[29] = t16;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  return t19;
}
function _temp4(item_2) {
  return <UserPageStatsActivityDistributionsTableItem key={`${item_2.collection}-${item_2.tokenId}-${item_2.wallet}`} item={item_2} />;
}
function _temp3(phase_1) {
  return <th key={getRandomObjectId()} scope="col" className="tw-group tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-right tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md lg:tw-pl-4">{capitalizeEveryWord(phase_1.replaceAll("_", " "))}</th>;
}
function _temp2(t0) {
  const {
    phase,
    item: item_0
  } = t0;
  let count;
  if (phase.toUpperCase() === "AIRDROP") {
    count = item_0.airdrops;
  } else {
    const p_0 = item_0.allowlist.find(a => a.phase === phase);
    count = p_0?.spots ?? 0;
  }
  return count ?? 0;
}
function _temp(contract) {
  if (areEqualAddresses(contract, MEMES_CONTRACT)) {
    return DistributionCollection.MEMES;
  }
  if (areEqualAddresses(contract, GRADIENT_CONTRACT)) {
    return DistributionCollection.GRADIENTS;
  }
  if (areEqualAddresses(contract, MEMELAB_CONTRACT)) {
    return DistributionCollection.MEMELAB;
  }
  throw new Error(`Unknown contract ${contract}`);
}